export default {
  label: 'CPF',
  hint: 'Je bank heeft je CPF nodig voor deze betaling. We geven deze door en bewaren hem niet.',
  invalid: 'Dat is geen geldige CPF. Controleer de 11 cijfers.',
};
